import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=aa69d828&"
import script from "./Forms.vue?vue&type=script&lang=js&"
export * from "./Forms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa69d828')) {
      api.createRecord('aa69d828', component.options)
    } else {
      api.reload('aa69d828', component.options)
    }
    module.hot.accept("./Forms.vue?vue&type=template&id=aa69d828&", function () {
      api.rerender('aa69d828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/welcome/actionItems/Forms.vue"
export default component.exports